import { colors } from "@material-ui/core";
import { CellParams } from "@material-ui/data-grid";
import { MathAction } from "features/admin/types";
import React from "react";
import styled from "styled-components/macro";

interface UpdatableCountFieldProps {
  onMinusClickHandler: any;
  onPlusClickHandler: any;
  rowParams: CellParams;
  isMinusDisabled?: boolean;
  isPlusDisabled?: boolean;
}

const UpdatableCountField: React.FC<UpdatableCountFieldProps> = ({
  onMinusClickHandler,
  onPlusClickHandler,
  rowParams,
  isMinusDisabled = false,
  isPlusDisabled = false,
}) => {
  const updateProductOrdered = (
    ev: any,
    params: CellParams,
    action: MathAction
  ) => {
    ev.preventDefault();

    switch (action) {
      case MathAction.plus:
        onPlusClickHandler(params);
        break;
      case MathAction.minus:
        onMinusClickHandler(params);
        break;
      default:
        break;
    }
  };

  return (
    <CenteredTableRow>
      <Button
        onClick={(e) => updateProductOrdered(e, rowParams, MathAction.minus)}
        className="minus-button"
        disabled={isMinusDisabled}
      >
        -
      </Button>
      {rowParams.row.ordered}
      <Button
        className="plus-button"
        onClick={(e) => updateProductOrdered(e, rowParams, MathAction.plus)}
        disabled={isPlusDisabled}
      >
        +
      </Button>
    </CenteredTableRow>
  );
};

export const CenteredTableRow = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
`;

export const Button = styled.button`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  cursor: pointer;
  border: none;
  background-color: ${colors.green[500]};
  border-radius: 5px;
  height: 50%;
  color: white;

  &:hover {
    background-color: ${colors.green[700]};
  }

  &:disabled {
    background-color: ${colors.grey[500]};
    color: ${colors.grey[300]};
  }

  &.plus-button {
    margin-left: 10px;
  }

  &.minus-button {
    margin-right: 10px;
  }
`;

export default UpdatableCountField;
